/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationLabelPostRequest
 */
export interface ConversationLabelPostRequest {
    /**
     * Labels for the conversation. If one label contains : it means its a scoped label
     * @type {Array<string>}
     * @memberof ConversationLabelPostRequest
     */
    labels: Array<string>;
}

/**
 * Check if a given object implements the ConversationLabelPostRequest interface.
 */
export function instanceOfConversationLabelPostRequest(value: object): value is ConversationLabelPostRequest {
    if (!('labels' in value) || value['labels'] === undefined) return false;
    return true;
}

export function ConversationLabelPostRequestFromJSON(json: any): ConversationLabelPostRequest {
    return ConversationLabelPostRequestFromJSONTyped(json, false);
}

export function ConversationLabelPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationLabelPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'],
    };
}

export function ConversationLabelPostRequestToJSON(json: any): ConversationLabelPostRequest {
    return ConversationLabelPostRequestToJSONTyped(json, false);
}

export function ConversationLabelPostRequestToJSONTyped(value?: ConversationLabelPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
    };
}

